import clsx from "clsx";
import React from "react";
import { Text } from "web/react/emo/text";
import { gettext } from "web/script/modules/django-i18n";
import * as styles from "./clear-filter-button.css";

interface ClearFilterButtonProps {
    onClick: () => void;
    active: boolean;
    className?: string;
}

export function ClearFilterButton({
    active,
    onClick,
    className,
}: ClearFilterButtonProps): JSX.Element {
    return (
        <button
            data-testid="clear-filters"
            onClick={onClick}
            disabled={!active}
            className={clsx(styles.clearButton, className, {
                [styles.clearButtonDisabled]: !active,
            })}
        >
            <Text textStyle="footnote">
                {
                    // "Clear"
                    gettext("feed.filters.clear_btn_text")
                }
            </Text>
        </button>
    );
}
